export enum PlanStepTypes {
  INFO = 'INFO',
  RELEASE = 'RELEASE',
  DELETE = 'DELETE',
  APPLY_CHANGES = 'APPLY_CHANGES'
}
